module.exports = __webpack_public_path__ + "static/media/img2.6a955a9f.svg";